import {
  Box,
  CircularProgress,
  FormLabel,
  Grid,
  InputAdornment,
  Pagination,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tabs from "../../pages/dashboard/Tabs";
import CustomerList from "../../pages/dashboard/CustomerList";
import { useAuth } from "../../hooks/useAuth";
import Style from "./DashboardTabs.module.css";
import { getList } from "../../services/userServices";
import {
  setYesterdaysList,
  setTodaysList,
  setTomorrowsList,
  setYestedaysCount,
  setTodaysCount,
  setTomorrowsCount,
  setRestaurantsList,
  setSelectedContacts,
} from "../../redux/slices/masterDataSlice";
import {
  ENDPOINT,
  ENDPOINT_MIDDLEWARE,
  ERROR_ACTIONS,
  TOAST_CONFIG,
  USER_TYPE,
} from "../../config/constants";
import { Search } from "@mui/icons-material";
import Reservations from "../../pages/dashboard/Reservations";
import { GET, MIDDLEWARE_POST, POST_MULTIPART } from "../../services/axiosRequestHandler";
import { toast } from "react-toastify";
import NoDataFound from "../../assets/images/no-data.svg";
import { PAGE_SIZE } from "../../config/config";
import { useLocation } from "react-router-dom";
import CustomSpinner from "../loader/CustomSpinner";

const ReservationTab = ({ filterByTime, counter, restIdFromLiveTable, refresh }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    reservationCount,
    yesterdaysList,
    todaysList,
    tomorrowsList,
    restaurantsList,
  } = useSelector((state) => state.masterData);
  const { selectedContacts } = useSelector((state) => state.masterData);
  const { logout, role } = useAuth();
  const [searchKey, setSearchKey] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryState, setCategoryState] = useState("");
  const [activeSubTab, setActiveSubTab] = useState("today");
  const [restId, setRestId] = useState("");
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchLoading, setSearchLoading] = useState(false);
  const [refreshOriginalListing, setRefreshOriginalListing] = useState(0);
  const [totalCountToday, setTotalCountToday] = useState(todaysList?.data);
  const [totalCountYesterday, setTotalCountYesterday] = useState(yesterdaysList?.data);
  const [totalCountTommorow, setTotalCountTommorow] = useState(tomorrowsList?.data);
  const [togglePosition, setTogglePosition] = useState(1);
  const [isToggleClicked, setToggleClicked] = useState(false);

  const tabsData = [
    {
      name: "Yesterday",
      id: "yesterday",
      count: reservationCount?.yesterday,
      totalCount: totalCountYesterday
    },
    {
      name: "Today",
      id: "today",
      count: reservationCount?.today,
      totalCount: totalCountToday
    },
    {
      name: "Tomorrow",
      id: "tomorrow",
      count: reservationCount?.tomorrow,
      totalCount: totalCountTommorow
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await getTodaysList();
        await getYesterdaysList();
        await getTomorrowsList();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (!isToggleClicked) {
      fetchData();
    }
  }, [restId, currentPage, isToggleClicked, filterByTime, restIdFromLiveTable, refresh]);

  useEffect(() => {
    !location.pathname.includes('/live-table') && getAllRestaurants();
    // getAllRestaurants()
  }, []);

  useEffect(() => {
    setSearchData(getDataToRender());
    setTotalPageCount(
      getRecordCount() > PAGE_SIZE ? Math.ceil(getRecordCount() / PAGE_SIZE) : 0
    );
  }, [loading, activeSubTab, restId, refreshOriginalListing]);

  useEffect(() => {
    const searchDataTimeout = setTimeout(() => {
      searchKey ? searchList() : getData();
    }, 1000);

    return () => {
      clearTimeout(searchDataTimeout);
      setSearchData([]);
      setSearchLoading(true);
    };
  }, [searchKey, restId, activeSubTab]);

  const getData = async (position= 1) => {
    if (activeSubTab === "yesterday") {
      await getYesterdaysList();
    } else if (activeSubTab === "today") {
      await getTodaysList(position);
    } else if (activeSubTab === "tomorrow") {
      await getTomorrowsList();
    }
    setRefreshOriginalListing((prev) => prev + 1);
    setSearchLoading(false);
  };

  const searchList = async () => {
    setSearchData([]);
    try {
      const payload = new FormData();
      payload.append("restId", restId);
      payload.append("search", searchKey);
      const resp = await POST_MULTIPART(
        role === USER_TYPE.MANAGER
          ? activeSubTab === "yesterday"
            ? ENDPOINT.SEARCH_YESTERDAYS_LIST_ADMIN
            : activeSubTab === "today"
              ? ENDPOINT.SEARCH_TODAYS_LIST_ADMIN
              : activeSubTab === "tomorrow"
                ? ENDPOINT.SEARCH_TOMORROWS_LIST_ADMIN
                : ""
          : activeSubTab === "yesterday"
            ? ENDPOINT.SEARCH_YESTERDAYS_LIST
            : activeSubTab === "today"
              ? ENDPOINT.SEARCH_TODAYS_LIST
              : activeSubTab === "tomorrow"
                ? ENDPOINT.SEARCH_TOMORROWS_LIST
                : "",
        payload
      );
      if (resp?.response?.data?.status === 200) {
        setSearchData(resp?.response?.data?.data);
        updateCounts(resp?.response?.data);
      } else if (resp?.response?.data?.status === 401) {
        toast.error("Your session has expired!", TOAST_CONFIG);
        logout();
      } else {
        toast.error(resp?.response?.data?.message, TOAST_CONFIG);
      }
    } catch (error) {
      toast.error(error?.message, TOAST_CONFIG);
    } finally {
      setSearchLoading(false);
    }
  };

  const updateCounts = (data) => {
    if (activeSubTab === "yesterday") {
      setTotalCountYesterday(data);
      dispatch(setYesterdaysList(data));
      dispatch(setYestedaysCount(data?.data?.length));
    } else if (activeSubTab === "today") {
      setTotalCountToday(data);
      dispatch(setTodaysList(data));
      dispatch(setTodaysCount(data?.data?.length));
    } else if (activeSubTab === "tomorrow") {
      setTotalCountTommorow(data);
      dispatch(setTomorrowsList(data));
      dispatch(setTomorrowsCount(data?.data?.length));
    }
  };

  const getAllRestaurants = async () => {
    try {
      const resp = await GET(
        role === USER_TYPE.MANAGER
          ? ENDPOINT.GET_ALL_RESTAURANTS_FOR_ADMIN
          : ENDPOINT.GET_ALL_RESTAURANTS
      );
      if (resp?.response?.data?.status === 200) {
        dispatch(setRestaurantsList(resp?.response?.data));
      } else if (resp?.response?.data?.status === 401) {
        toast.error("Your session has expired!", TOAST_CONFIG);
        logout();
      } else {
        toast.error(resp?.response?.data?.message, TOAST_CONFIG);
      }
    } catch (error) {
      toast.error(error?.message, TOAST_CONFIG);
    }
  };

  const getYesterdaysList = async () => {
    const payload = new FormData();
    payload.append("previousCount", currentPage * PAGE_SIZE - PAGE_SIZE);
    payload.append("restId", restId);
    const resp = await getList(
      "POST",
      role === USER_TYPE.MANAGER
        ? ENDPOINT.GET_YESTERDAYS_LIST_ADMIN
        : ENDPOINT.GET_YESTERDAYS_LIST,
      payload
    );
    if (!resp?.error) {
      setTotalCountYesterday(resp?.data);
      dispatch(setYesterdaysList(resp?.data));
      dispatch(setYestedaysCount(resp?.data?.totalRecordsCount || 0));
    } else if (resp?.error === ERROR_ACTIONS.SESSION_EXPIRED) {
      logout();
    }
  };

  const getTodaysList = async (position=1) => {
    const payload = new FormData();
    payload.append("previousCount", currentPage * PAGE_SIZE - PAGE_SIZE);
    payload.append("restId", restIdFromLiveTable || restId || "");
    payload.append("filterBy", position);
    payload.append("filterByTime", filterByTime);
    payload.append("page", currentPage);
    let resp = {}
    if(location.pathname === '/live-table'){
      resp = await MIDDLEWARE_POST(ENDPOINT_MIDDLEWARE.GET_TODAYS_LIST, payload);
    }else{
      resp = await MIDDLEWARE_POST(ENDPOINT_MIDDLEWARE.GET_TODAY_RESERVATION_COUNT, payload);
    }
    if (!resp?.response?.error) {
      let reservationData = {};
      let reservationDataLength = 0;
      if(location.pathname === '/live-table'){
        const allReservations = resp?.response?.data?.data?.flatMap(item => item.reservation) || [];
        const uniqueReservations = Array.from(
          new Map(allReservations.map(item => [item.reservationId, item])).values()
        );
        reservationDataLength = allReservations.length;
        reservationData = {
          data: uniqueReservations,
        }
      }else{
        reservationData = resp?.response?.data;
        reservationDataLength = resp?.response?.data?.totalRecordsCount;
      }
      setTotalCountToday(reservationDataLength || 0);
      dispatch(setTodaysList(reservationData));
      dispatch(setTodaysCount(reservationDataLength || 0));
    } else if (resp?.error === ERROR_ACTIONS.SESSION_EXPIRED) {
      logout();
    }
  };

  const getTomorrowsList = async () => {
    const payload = new FormData();
    payload.append("previousCount", currentPage * PAGE_SIZE - PAGE_SIZE);
    payload.append("restId", restId);

    const resp = await getList(
      "POST",
      role === USER_TYPE.MANAGER
        ? ENDPOINT.GET_TOMORROWS_LIST_ADMIN
        : ENDPOINT.GET_TOMORROWS_LIST,
      payload
    );
    if (!resp?.error) {
      setTotalCountTommorow(resp?.data);
      dispatch(setTomorrowsList(resp?.data));
      dispatch(setTomorrowsCount(resp?.data?.totalRecordsCount || 0));
    } else if (resp?.error === ERROR_ACTIONS.SESSION_EXPIRED) {
      logout();
    }
  };

  const getDataToRender = () => {
    if (activeSubTab === "yesterday") {
      return yesterdaysList?.data?.data || [];
    } else if (activeSubTab === "today") {
      return todaysList?.data?.data || [];
    } else if (activeSubTab === "tomorrow") {
      return tomorrowsList?.data?.data || [];
    } else {
      return [];
    }
  };

  const getRecordCount = () => {
    if (activeSubTab === "yesterday") {
      return yesterdaysList?.data?.totalRecordsCount || 0;
    } else if (activeSubTab === "today") {
      return todaysList?.data?.totalRecordsCount || 0;
    } else if (activeSubTab === "tomorrow") {
      return tomorrowsList?.data?.totalRecordsCount || 0;
    } else {
      return 0;
    }
  };

  const handleSelectAll = () => {
    const allIds = searchData?.map((data) => data.contactNo);
    dispatch(setSelectedContacts(allIds));
  };

  const deselectAll = () => {
    dispatch(setSelectedContacts([]));
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    dispatch(setSelectedContacts([]));
  };

  const handleCategoryOptionPillClick = (newCategoryOption) => {
    if (newCategoryOption.id === categoryState.id) {
      setCurrentPage(1);
      setTogglePosition(1);
      setCategoryState("");
      setToggleClicked(false);
      setRestId("");
      return;
    }
    setCategoryState(newCategoryOption);
    setRestId(newCategoryOption.id);
    setCurrentPage(1);
    setTogglePosition(1);
    setToggleClicked(false);
    dispatch(setSelectedContacts([]));
  };
  const handleClick = () => {
    setTogglePosition((prevPosition) => {
      let newPosition;
      switch (prevPosition) {
        case 1:
          newPosition = 2;
          break;
        case 2:
          newPosition = 3;
          break;
        case 3:
          newPosition = 1;
          break;
        default:
          newPosition = 1;
      }
      setToggleClicked(true);
      setCurrentPage(1); // Reset pagination to page 1
      getData(newPosition); // Fetch data based on the new toggle position
      return newPosition;
    });
  };
  return (
    <>
      {location.pathname !== '/live-table' && (
        <Reservations
          categories={restaurantsList?.data?.data?.original}
          categoryState={categoryState}
          handleCategoryOptionPillClick={handleCategoryOptionPillClick}
        />
      )}
      <div className={Style.emptyLine}></div>
      {loading ? (
          <div className="loading-overlay">
          <CustomSpinner  />
        </div>
      ) : (
        <>
          <div className={Style.tabsWrapper}>
            {activeSubTab === 'today' && location.pathname !== '/live-table' && (
              <div
                className={Style.toggleContainer}
                onClick={() => handleClick()}
              >
                <div
                  className={`${Style.toggleSlider} ${
                    togglePosition === 1
                      ? Style.left
                      : togglePosition === 2
                      ? Style.middle
                      : Style.right
                  }`}
                >
                  <span className={Style.toggleLabel}></span>
                </div>
              </div>
            )}
            <Grid container>
              <Tabs
                tabs={location.pathname === '/live-table' ? [] : tabsData}
                activeTab={activeSubTab}
                setActiveTab={(param) => {
                  setActiveSubTab(param);
                  setCurrentPage(1);
                  setSearchKey("");
                  if (param === "today") {
                    setTogglePosition(1);
                  }
                }}
                totalCountToday={totalCountToday}
                totalCountTommorow={totalCountTommorow}
                totalCountYesterday={totalCountYesterday}
              />
            </Grid>
          </div>
          {location.pathname !== '/live-table' && (
            <div>
              <TextField
                id="searchName"
                name="searchName"
                fullWidth
                autoComplete="off"
                type="text"
                placeholder="Search"
                value={searchKey}
                onChange={handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  sx: {
                    textAlign: "end",
                  },
                }}
                sx={{
                  marginBottom: "30px",
                }}
              />
            </div>
          )}
          {role === USER_TYPE.MANAGER && searchData?.length > 0 && location.pathname !== '/live-table' && (
            <FormLabel
              onClick={
                searchData?.length === selectedContacts?.length
                  ? deselectAll
                  : handleSelectAll
              }
              sx={{ textDecoration: "", "&:hover": { cursor: "pointer" } }}
            >
              {searchData?.length === selectedContacts?.length
                ? "Deselect All"
                : "Select All"}
            </FormLabel>
          )}
          <Grid container spacing={2}>
            {searchData?.map((customer, index) => (
              <Grid
                key={`${customer.id}${index}`}
                item
                xs={12}
                sm={12}
                md={location.pathname === '/live-table' ? 12 : 6}
                lg={location.pathname === '/live-table' ? 6 : 4}
              >
                <CustomerList
                  usedin="reservation"
                  data={customer}
                  dashboardActions
                  showCheckBox={true}
                  reservation
                  restaurantsList={restaurantsList}
                  getData={getData}
                />
              </Grid>
            ))}
            <Grid item xs={12} lg={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 14,
                }}
              >
                {totalPageCount && searchData.length > 0 ? (
                  <Pagination
                    count={totalPageCount}
                    variant="outlined"
                    shape="rounded"
                    color="primary"
                    page={currentPage}
                    onChange={(event, value) => {
                      setToggleClicked(false);
                      setCurrentPage(value);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  />
                ) : null}
              </Box>
            </Grid>
            {!searchData?.length && !loading && !searchLoading && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <div className="noResultWrapper">
                  <img src={NoDataFound} alt="no-data-found" />
                  <Typography variant="h5">No data found!</Typography>
                </div>
              </Grid>
            )}
          </Grid>
          {searchLoading && (
            <div className={Style.loaderWrapper} style={{ height: "20vh" }}>
               <div className="loading-overlay">
                     <CustomSpinner  />
               </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ReservationTab;